import { DayValue } from "@amir04lm26/react-modern-calendar-date-picker";

export function fromDatePickerFormat(date: DayValue): string {
    if (!date) return '';
    return `${date.month < 10 ? `0${date.month}` : date.month}-${date.day < 10 ? `0${date.day}` : date.day}-${date?.year}`;
};

export function toDatePickerFormat(date: string | null): DayValue {
    let output = null;

    if (typeof date === 'string' && date !== '') {

        output = {
            year: Number(date?.slice(6)),
            month: Number(date?.slice(0, 2)),
            day: Number(date?.slice(3, 5))
        };
    }

    return output;
};

export function birthDateValidation(date: DayValue): boolean | undefined {
    if (!date) return;
    const { year, month, day } = date;
    var today = new Date();
    var age = today.getFullYear() - year;
    if (today.getMonth() < month || (today.getMonth() === month && today.getDate() < day)) {
        age--;
    }

    return age > 18;
};